<template>
    <div class="container-fluid bg-light min-vh-100 d-flex flex-column align-items-center">
      <HeaderPage>
        <br />
        <br />
        <!-- Bouton pour ouvrir la modal d'inscription -->
        <button class="btn btn-primary mb-3 create-article-btn" @click="openRegistrationModal">
          <i class="fas fa-plus"></i> Créer un utilisateur
        </button>
        <h3 class="my-4">Liste des utilisateurs</h3>
        <div class="table responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.nom }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <button class="btn btn-primary btn-sm" @click="openModal(user)">
                    Changer son rôle
                  </button>
                  <!-- Vous pouvez ajouter d'autres boutons (ex. éditer, supprimer) ici -->
                </td>
                <td>
                    <a href="#" @click.prevent="deleteArticle(article)" class="delete-btn">
                  <i class="fas fa-trash"></i>
                </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </HeaderPage>
  
      <!-- Modal pour modifier le rôle de l'utilisateur -->
      <div class="modal fade" id="roleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Modifier le rôle</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="changeUserRole">
                <div class="mb-3">
                  <label class="form-label">Sélectionner un rôle</label>
                  <select class="form-select" v-model="selectedRole">
                    <option v-for="role in roles" :key="role.id" :value="role.id">
                      {{ role.name }}
                    </option>
                  </select>
                </div>
                <div class="text-end">
                  <button type="submit" class="btn btn-primary" :disabled="loading">Modifier</button>
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Modal pour créer un nouvel utilisateur -->
      <div class="modal fade" id="registrationModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title">Inscription</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="registerUser">
                <!-- Nom -->
                <div class="mb-3">
                  <label for="nom" class="form-label">Nom</label>
                  <input type="text" id="nom" v-model="form.nom" class="form-control" required />
                </div>
                <!-- Email -->
                <div class="mb-3">
                  <label for="email" class="form-label">Email</label>
                  <input type="email" id="email" v-model="form.email" class="form-control" required />
                </div>
                <!-- Mot de passe -->
                <div class="mb-3">
                  <label for="motdepass" class="form-label">Mot de passe</label>
                  <input type="password" id="motdepass" v-model="form.motdepass" class="form-control" required />
                </div>
                <!-- Confirmation du mot de passe -->
                <div class="mb-3">
                  <label for="motdepass_confirmation" class="form-label">Confirmer le mot de passe</label>
                  <input type="password" id="motdepass_confirmation" v-model="form.motdepass_confirmation" class="form-control" required />
                </div>
                <!-- Rôle -->
                <div class="mb-3">
                  <label for="role" class="form-label">Rôle</label>
                  <select id="role" v-model="form.role" class="form-select">
                    <option value="user">Utilisateur</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <!-- Affichage des messages d'erreur ou de succès -->
                <div v-if="errorMessage" class="alert alert-danger">
                  {{ errorMessage }}
                </div>
                <div v-if="successMessage" class="alert alert-success">
                  {{ successMessage }}
                </div>
                <!-- Bouton de soumission -->
                <button type="submit" class="btn btn-primary w-100">S'inscrire</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  import HeaderPage from './components/HeaderPage.vue';
  import { Modal } from 'bootstrap';
  
  const API_URL = process.env.VUE_APP_API_URL;
  
  const users = ref([]);
  const roles = ref([]);
  const selectedUser = ref(null);
  const selectedRole = ref('');
  const loading = ref(false);
  
  let roleModalInstance = null;
  let registrationModalInstance = null;
  
  // Récupérer la liste des utilisateurs
  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/users/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      users.value = response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs :', error);
    }
  };
  
  // Récupérer la liste des rôles
  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/roles`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      roles.value = response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des rôles :', error);
    }
  };
  
  // Ouvrir la modal pour modifier le rôle d'un utilisateur
  const openModal = (user) => {
    selectedUser.value = user;
    selectedRole.value = user.role_id; // Prendre le rôle actuel par défaut
    if (!roleModalInstance) {
      roleModalInstance = new Modal(document.getElementById('roleModal'));
    }
    roleModalInstance.show();
  };
  
  // Fonction pour changer le rôle de l'utilisateur
  const changeUserRole = async () => {
    if (!selectedUser.value || !selectedRole.value) return;
    try {
      loading.value = true;
      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/api/user/change-role`, {
        user_id: selectedUser.value.id,
        role_id: selectedRole.value
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Mettre à jour localement
      selectedUser.value.role_id = selectedRole.value;
      // Fermer la modal après modification
      roleModalInstance.hide();
    } catch (error) {
      console.error('Erreur lors de la mise à jour du rôle :', error);
    } finally {
      loading.value = false;
    }
  };
  
  // Ouvrir la modal d'inscription
  const openRegistrationModal = () => {
    if (!registrationModalInstance) {
      registrationModalInstance = new Modal(document.getElementById('registrationModal'));
    }
    registrationModalInstance.show();
  };
  
  // Données et fonction pour l'inscription
  const form = ref({
    nom: '',
    email: '',
    motdepass: '',
    motdepass_confirmation: '',
    role: 'user'
  });
  const errorMessage = ref('');
  const successMessage = ref('');
  
  const registerUser = async () => {
    errorMessage.value = '';
    successMessage.value = '';
    try {
      const response = await axios.post(`${API_URL}/api/user/register`, null, {
        params: {
          nom: form.value.nom,
          email: form.value.email,
          motdepass: form.value.motdepass,
          motdepass_confirmation: form.value.motdepass_confirmation,
          role: form.value.role
        }
      });
      successMessage.value = response.data.message;
      // Réinitialiser le formulaire après une inscription réussie
      form.value.nom = '';
      form.value.email = '';
      form.value.motdepass = '';
      form.value.motdepass_confirmation = '';
      form.value.role = 'user';
      // Fermer la modal et rafraîchir la liste des utilisateurs
      registrationModalInstance.hide();
      fetchUsers();
    } catch (error) {
      if (error.response && error.response.data) {
        errorMessage.value = typeof error.response.data === 'object'
          ? Object.values(error.response.data).flat().join(' ')
          : error.response.data;
      } else {
        errorMessage.value = "Une erreur est survenue lors de l'inscription.";
      }
    }
  };
  
  onMounted(() => {
    fetchUsers();
    fetchRoles();
  });
  </script>
  
  <style scoped>
  .table {
    margin-top: 20px;
  }
  .delete-btn {
    color: #dc3545;
  }
  </style>
  